import { withStyles } from "tss-react/mui";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSack } from "@fortawesome/pro-solid-svg-icons/faSack";
import { FreeBreakfast, ShoppingBasket } from "@mui/icons-material";
import axios from "axios";
import React from "react";
import { connect } from "react-redux";
import rapportenStyle from "../../../assets/jss/material-dashboard-pro-react/views/rapportenStyle";
import Card from "../../../components/Card/Card";
import CardFooter from "../../../components/Card/CardFooter";
import CardHeader from "../../../components/Card/CardHeader";
import CardIcon from "../../../components/Card/CardIcon";
import GridContainer from "../../../components/Grid/GridContainer";
import GridItem from "../../../components/Grid/GridItem";
import * as actions from "../../../store/actions";
import { formatValuta } from "../../../utils";
import Filters from "../Components/Filters";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { toast } from "react-toastify";
import { format } from "date-fns";

class Main extends React.Component {
  state = {
    aantalBestellingen: 0,
    aantalBestellingenWithGiftcard: 0,
    aantalBestellingenUnPaid: 0,
    omzet: 0,
    hoursstat: [],
    daily7: [],
    omzetUnpaid: 0,
    aantalProducten: 0,
    aantalProductenNotpaid: 0,
    gemiddeldeBestelwaarde: 0,
    gemiddeldeBestelwaardeNotpaid: 0,
    gemiddeldeBestelwaardeCombined: 0,
    omzetGiftcard: 0,
    productAantalOverPeriode: {},
    paymentTypes: {},
  };

  currentReqeust;

  componentWillUnmount() {
    /**
     * Current request annuleren bij snel klikken kan zijn dat die nog niet klaar is
     */
    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }
  }

  getData = (filterData) => {
    toast.info(<TranslationWrapper tDefault={"laden"} tKey={"global.laden"} />);

    if (!filterData.eind_datum || !filterData.start_datum) {
      return;
    }

    let data = {
      vestiging_ids:
        filterData.vestiging_ids.length == 1 && filterData.vestiging_ids.includes("all")
          ? []
          : filterData.vestiging_ids,
      start_datum: format(new Date(filterData.start_datum), "yyyy-M-d HH:mm:ss"),
      eind_datum: format(new Date(filterData.eind_datum), "yyyy-M-d HH:mm:ss"),
    };

    if (this.currentReqeust !== undefined) {
      this.currentReqeust.cancel();
    }

    const CancelToken = axios.CancelToken;
    this.currentReqeust = CancelToken.source();
    let cancelToken = this.currentReqeust.token;

    axios
      .post("core/rapporten/genereer", data, {
        cancelToken: cancelToken,
      })
      .then((response) => {
        let newState = { ...this.state, ...response.data.data };
        this.setState(newState);
      })
      .catch((error) => {
        /**
         * Alleen niet CANCEL errors afvangen
         */
        if (!error.__CANCEL__) {
          toast.error(
            <TranslationWrapper tDefault={"Oeps er is iets misgegaan!"} tKey={"global.rapporten.errormessage"} />
          );
        }
      });
  };

  render() {
    const { classes } = this.props;

    const COLORS = ["#b3b300", "#b37400", "#9d4e15", "#b30000", "#cc0022", "#b300b3", "#6918b4", "#0000b3", "#00b300"];

    /**
     * Object naar array conversie, ander snapt het chart ding het niet
     */
    /* let dataSet = [];
    let dataSet7Days = [];*/
    let paymentMethods = [];
    let top10Products = [];
    let paidVsUnpaid = [
      {
        name: "paid orders",
        items: parseInt(this.state.aantalProducten),
        orders: parseInt(this.state.aantalBestellingen),
      },
      {
        name: "unpaid orders",
        items: parseInt(this.state.aantalProductenNotpaid),
        orders: parseInt(this.state.aantalBestellingenUnPaid),
      },
    ];
    /* for (const [key, data] of Object.entries(this.state.hoursstat)) {
      data.difference = data.current - data.prev;
      dataSet[key] = data;
    }
    for (const [key, data] of Object.entries(this.state.daily7)) {
      data.difference = data.current - data.prev;
      dataSet7Days[key] = data;
    }*/
    for (const [key, data] of Object.entries(this.state.paymentTypes)) {
      paymentMethods[key] = data;
    }
    /*   for (const [key, data] of Object.entries(this.state.productAantalOverPeriode)) {
      top10Products[key] = {
        name: data.label,
        aantal: data.aantal,
      };
    }*/
    return (
      <div>
        <Filters ShowReload onFilterChange={this.getData} showEndDateDate showStartDateDate showVestigingen />
        <GridContainer>
          <GridItem lg={12} md={12} sm={12} xs={12}>
            <GridContainer>
              <GridItem lg={12} md={12} sm={12} xs={12}>
                <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Total paid+unpaid orders</h4>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalBestellingen + this.state.aantalBestellingenUnPaid}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Bestellingen over periode"}
                        tKey={"rapportages.rapporten.bestellingen.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.omzet + this.state.omzetUnpaid)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Omzet over periode"}
                        tKey={"rapportages.rapporten.omzet.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FreeBreakfast />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {parseInt(this.state.aantalProducten) + parseInt(this.state.aantalProductenNotpaid)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Aantal producten over periode"}
                        tKey={"rapportages.rapporten.producten.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.gemiddeldeBestelwaardeCombined)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Gemiddelde bestelwaarde"}
                        tKey={"rapportages.rapporten.bestelwaarde.gemiddelde"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem lg={12} md={12} sm={12} xs={12}>
                <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Paid orders</h4>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalBestellingen}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Bestellingen over periode"}
                        tKey={"rapportages.rapporten.bestellingen.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.omzet)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Omzet over periode"}
                        tKey={"rapportages.rapporten.omzet.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FreeBreakfast />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalProducten}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Aantal producten over periode"}
                        tKey={"rapportages.rapporten.producten.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.gemiddeldeBestelwaarde)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Gemiddelde bestelwaarde"}
                        tKey={"rapportages.rapporten.bestelwaarde.gemiddelde"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem lg={12} md={12} sm={12} xs={12}>
                <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Unpaid orders</h4>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalBestellingenUnPaid}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Bestellingen over periode"}
                        tKey={"rapportages.rapporten.bestellingen.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.omzetUnpaid)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Omzet over periode"}
                        tKey={"rapportages.rapporten.omzet.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FreeBreakfast />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalProductenNotpaid}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Aantal producten over periode"}
                        tKey={"rapportages.rapporten.producten.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.gemiddeldeBestelwaardeNotpaid)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Gemiddelde bestelwaarde"}
                        tKey={"rapportages.rapporten.bestelwaarde.gemiddelde"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem lg={12} md={12} sm={12} xs={12}>
                <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Orders with giftcard</h4>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.aantalBestellingenWithGiftcard}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Bestellingen over periode"}
                        tKey={"rapportages.rapporten.bestellingengiftcard.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.omzetGiftcard)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Omzet giftcards periode"}
                        tKey={"rapportages.rapporten.omzetgiftcard.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={12} md={12} sm={12} xs={12}>
                <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>AI Orders</h4>
              </GridItem>
              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <ShoppingBasket />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {this.state.itemsAiUpsell}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"Bestellingen over periode"}
                        tKey={"rapportages.rapporten.ordersomzetai.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>

              <GridItem lg={3} md={6} sm={6} xs={12}>
                <Card>
                  <CardHeader color={"primary"} icon stats style={{ padding: "10px 0px 0px 10px" }}>
                    <CardIcon color={"primary"}>
                      <FontAwesomeIcon icon={faSack} />
                    </CardIcon>
                    <h3
                      className={classes.cardTitle}
                      style={{ paddingLeft: "50px", fontSize: "120%", fontWeight: "bold" }}
                    >
                      {formatValuta(this.state.omzetAiUpsell)}
                    </h3>
                  </CardHeader>
                  <CardFooter stats>
                    <div className={classes.stats}>
                      <TranslationWrapper
                        tDefault={"AI omzet over periode"}
                        tKey={"rapportages.rapporten.omzetai.periode"}
                      />
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem lg={6} md={12} sm={12} xs={12}>
                <GridContainer style={{ minHeight: "350px" }}>
                  <GridItem align={"left"} lg={12} md={12} sm={12} xs={12}>
                    <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Used payment methods / paid revenue</h4>
                  </GridItem>
                  <GridItem align={"center"} lg={12} md={12} sm={12} xs={12}>
                    <ResponsiveContainer height={"100%"} width={"100%"}>
                      <PieChart height={400} width={400}>
                        <Pie
                          cx={"50%"}
                          cy={"50%"}
                          data={paymentMethods}
                          dataKey={"aantal"}
                          fill={"#8884d8"}
                          innerRadius={0}
                          label
                          outerRadius={45}
                          paddingAngle={0}
                        >
                          {top10Products.map((entry, index) => (
                            <Cell fill={COLORS[index % COLORS.length]} key={`cell-${index}`} />
                          ))}
                        </Pie>
                        <Pie
                          cx={"50%"}
                          cy={"50%"}
                          data={paymentMethods}
                          dataKey={"omzet"}
                          fill={"#8884d8"}
                          innerRadius={55}
                          label
                          outerRadius={100}
                          paddingAngle={0}
                        >
                          {top10Products.map((entry, index) => (
                            <Cell fill={COLORS[index % COLORS.length]} key={`cell-${index}`} />
                          ))}
                        </Pie>
                        <Tooltip />
                        {/* <Legend /> */}
                      </PieChart>
                    </ResponsiveContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>
              <GridItem lg={6} md={12} sm={12} xs={12}>
                <GridContainer style={{ minHeight: "350px" }}>
                  <GridItem align={"left"} lg={12} md={12} sm={12} xs={12}>
                    <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Paid vs Unpaid (orders/products)</h4>
                  </GridItem>
                  <GridItem align={"center"} lg={12} md={12} sm={12} xs={12}>
                    <ResponsiveContainer height={"100%"} width={"100%"}>
                      <PieChart height={400} width={400}>
                        <Pie
                          cx={"50%"}
                          cy={"50%"}
                          data={paidVsUnpaid}
                          dataKey={"orders"}
                          fill={"#8884d8"}
                          innerRadius={0}
                          label
                          outerRadius={45}
                          paddingAngle={0}
                        >
                          {top10Products.map((entry, index) => (
                            <Cell fill={COLORS[index % COLORS.length]} key={`cell-${index}`} />
                          ))}
                        </Pie>
                        <Pie
                          cx={"50%"}
                          cy={"50%"}
                          data={paidVsUnpaid}
                          dataKey={"items"}
                          fill={"#8884d8"}
                          innerRadius={55}
                          label
                          outerRadius={100}
                          paddingAngle={0}
                        >
                          {top10Products.map((entry, index) => (
                            <Cell fill={COLORS[index % COLORS.length]} key={`cell-${index}`} />
                          ))}
                        </Pie>
                        <Tooltip />
                        {/* <Legend /> */}
                      </PieChart>
                    </ResponsiveContainer>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </GridContainer>
          </GridItem>
          {/*<GridItem xs={12} sm={12} md={6} lg={6}>*/}
          {/*  <GridContainer style={{ minHeight: "400px" }}>*/}
          {/*    <GridItem xs={12} sm={12} md={12} lg={12} align="left">*/}
          {/*      <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Orders last 24 hours per 60 minutes</h4>*/}
          {/*    </GridItem>*/}
          {/*    <GridItem xs={12} sm={12} md={12} lg={12} align="center">*/}
          {/*      <ResponsiveContainer width="100%" height="100%">*/}
          {/*        <LineChart*/}
          {/*          width={500}*/}
          {/*          height={300}*/}
          {/*          data={dataSet}*/}
          {/*          margin={{*/}
          {/*            top: 20,*/}
          {/*            right: 10,*/}
          {/*            left: 0,*/}
          {/*            bottom: 5,*/}
          {/*          }}*/}
          {/*        >*/}
          {/*          <CartesianGrid strokeDasharray="3 3" />*/}
          {/*          <XAxis dataKey="name" />*/}
          {/*          <YAxis />*/}
          {/*          <Tooltip />*/}
          {/*          <Legend />*/}
          {/*          <Line*/}
          {/*            type="monotone"*/}
          {/*            name="Current period"*/}
          {/*            dataKey="current"*/}
          {/*            stroke="#4caf50"*/}
          {/*            activeDot={{ r: 8 }}*/}
          {/*          />*/}
          {/*          <Line type="monotone" name="Previous period" dataKey="prev" stroke="#f50057" />*/}
          {/*          <Line type="monotone" name="Period difference" dataKey="difference" stroke="#9090ff" />*/}
          {/*        </LineChart>*/}
          {/*      </ResponsiveContainer>*/}
          {/*    </GridItem>*/}
          {/*  </GridContainer>*/}
          {/*  <GridContainer style={{ minHeight: "400px" }}>*/}
          {/*    <GridItem xs={12} sm={12} md={12} lg={12}>*/}
          {/*      <h4 style={{ marginTop: "5px", marginBottom: "0px" }}>Orders last 7 days per day</h4>*/}
          {/*    </GridItem>*/}
          {/*    <GridItem xs={12} sm={12} md={12} lg={12} align="center">*/}
          {/*      <ResponsiveContainer width="100%" height="100%">*/}
          {/*        <LineChart*/}
          {/*          width={500}*/}
          {/*          height={300}*/}
          {/*          data={dataSet7Days}*/}
          {/*          margin={{*/}
          {/*            top: 20,*/}
          {/*            right: 10,*/}
          {/*            left: 0,*/}
          {/*            bottom: 5,*/}
          {/*          }}*/}
          {/*        >*/}
          {/*          <CartesianGrid strokeDasharray="3 3" />*/}
          {/*          <XAxis dataKey="name" />*/}
          {/*          <YAxis />*/}
          {/*          <Tooltip />*/}
          {/*          <Legend />*/}
          {/*          <Line*/}
          {/*            type="monotone"*/}
          {/*            name="Current period"*/}
          {/*            dataKey="current"*/}
          {/*            stroke="#4caf50"*/}
          {/*            activeDot={{ r: 8 }}*/}
          {/*          />*/}
          {/*          <Line type="monotone" name="Previous period" dataKey="prev" stroke="#f50057" />*/}
          {/*          <Line type="monotone" name="Period difference" dataKey="difference" stroke="#9090ff" />*/}
          {/*        </LineChart>*/}
          {/*      </ResponsiveContainer>*/}
          {/*    </GridItem>*/}
          {/*  </GridContainer>*/}
          {/*</GridItem>*/}
        </GridContainer>
        <GridContainer />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(null, mapDispatchToProps)(withStyles(Main, rapportenStyle));
